<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="userPaysheets"
            :items-per-page="5"
            :items-per-page-options="[5, 10, 20]"
            class="elevation-0"
        >
            <template v-slot:item="{ item }">
                <tr v-if="$vuetify.breakpoint.smAndUp" style="height: 100px; background-color: #f0f0f0;">
                    <td>
                        <v-icon large color="red">mdi-file-pdf-box</v-icon>
                    </td>
                    <td>{{ item.account.nombre_completo }}</td>
                    <td>{{ item.month.slice(0, 7) }}</td>
                    <td>
                        <a :href="item.paysheet" target="_blank" download style=" text-decoration: none;">
                            <v-icon large color="green">mdi-file-download-outline</v-icon>
                        </a>
                    </td>
                    <td v-if="hasAdminPermission">
                        <v-icon @click="deletePaysheet(item.id)" large color="red">mdi-delete-outline</v-icon>
                    </td>
                </tr>
                <tr v-else style="background-color: #f0f0f0;" class="pa-6">
                    <div class="d-flex flex-column justify-space-between">
                        <p class="d-flex justify-space-between"><strong>Nombre: </strong> {{ item.account.nombre_completo }}</p>
                        <p class="d-flex justify-space-between"><strong>Mes: </strong> {{ item.month.slice(0, 7) }}</p>
                        <div class="d-flex justify-space-around">
                            <a :href="item.paysheet" target="_blank" download style=" text-decoration: none;">
                                <v-icon large color="green">mdi-file-download-outline</v-icon>
                            </a>
                            <v-icon @click="deletePaysheet(item.id)" large color="red">mdi-delete-outline</v-icon>
                        </div>
                    </div>
                </tr>
                <v-divider v-if="!$vuetify.breakpoint.smAndUp"></v-divider>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { clone } from '@/util/libUtil.js';


export default {
    data: ()=> ({
        headers: [
            { text: '', value: '' },
            { text: 'Nombre', value: 'account.nombre_completo' },
            { text: 'Mes', value: 'month' },
            { text: 'Descargar', value: 'paysheet' },
            { text: 'Eliminar', value: 'delete' },
        ],
    }), 
    computed: {
		...mapGetters('login', {
			hasAdminPermission: 'hasAdminPermission',
		}),
        ...mapState('storage', {
            userPaysheets: state => state.userPaysheets.paysheets,
        }),
    },
    methods: {
        deletePaysheet(id) {
            let deleteObj = {
                toDeleteId: id,
                toDeleteType: 'STORAGE_PAYSHEET',
                isOpenDeleteDialog: true,
            };

            this.$store.commit('util/deleteDialog', clone(deleteObj));
        }
    },
    beforeMount() {
        if (!this.hasAdminPermission) {
            this.headers.splice(4, 1);
        }
    }
}
</script>


<style scoped>
.grey-card {
    background-color: #f0f0f0;
}
</style>